export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5489.b2a5f436.jpg";